import tippyJs, { Placement } from 'tippy.js';
import { Component, ViewChild, ElementRef, AfterViewInit, OnDestroy, Input } from '@angular/core';

@Component({
  selector: 'studio-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent implements AfterViewInit, OnDestroy {
  @ViewChild('triggerEl', { static: false }) trigger: ElementRef;
  @ViewChild('tooltipEl', { static: false }) tooltip: ElementRef;
  @Input() public triggerType = 'click';
  @Input() public offset: [number, number] = [20, 20];
  @Input() public placement: Placement = 'auto';
  private instance;

  ngAfterViewInit() {
    this.instance = tippyJs(this.trigger.nativeElement, {
      content: this.tooltip.nativeElement,
      allowHTML: true,
      interactive: true,
      trigger: this.triggerType,
      maxWidth: 'auto',
      offset: this.offset,
      duration: [0, 0],
      placement: this.placement,
    });
  }

  ngOnDestroy() {
    this.instance.destroy();
  }
}
